/**
 * 2D mixtape sleeve for reduced-motion Finder tiles.
 */

import { useEffect, useRef } from 'react';
import {
  drawMusicSleeve,
  MUSIC_SLEEVE_HEIGHT,
  MUSIC_SLEEVE_WIDTH,
} from '@/lib/musicSleeve';

export function MusicSleeveThumb({
  title,
  artist,
  nowPlaying,
}: {
  title: string;
  artist?: string;
  nowPlaying?: boolean;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) return;
    drawMusicSleeve(ctx, { title, artist, nowPlaying });
  }, [title, artist, nowPlaying]);

  return (
    <canvas
      ref={canvasRef}
      width={MUSIC_SLEEVE_WIDTH}
      height={MUSIC_SLEEVE_HEIGHT}
      aria-hidden
      style={{ width: '100%', aspectRatio: '3 / 4', objectFit: 'cover', borderRadius: 4 }}
    />
  );
}
